import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import AddLocalDevApp from 'features/apps/add-local-dev-app/components';

const AddLocalDevAppPage = () => {
  return (
    <>
      <Navbar showPreviousBtn />
      <Box css={{ height: 'calc( 100vh - 58px )' }}>
        <AddLocalDevApp />
      </Box>
    </>
  );
};

export default AddLocalDevAppPage;
